module.exports = __webpack_public_path__ + "assets/1491973d72a358e72bac585f8eea7cc3.svg";